import { render, staticRenderFns } from "./CBreadcrumbRouter.vue?vue&type=template&id=51003862&"
import script from "./CBreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./CBreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports